import PropTypes from 'prop-types'

export const AlignItemsPropTypes = PropTypes.oneOf([
  'start',
  'end',
  'stretch',
  'baseline',
  'center'
])

export const AlignSelfPropTypes = PropTypes.oneOf([
  'start',
  'end',
  'stretch',
  'baseline',
  'center',
  'auto'
])

export const AlignContentPropTypes = PropTypes.oneOf([
  'start',
  'end',
  'between',
  'around',
  'center'
])

export const JustifyContentPropTypes = PropTypes.oneOf([
  'start',
  'end',
  'between',
  'around',
  'center'
])

export const RowFlexPropTypes = PropTypes.oneOf([
  'row',
  'row-reverse',
  'column',
  'column-reverse',
  'wrap',
  'wrap-reverse',
  'nowrap'
])

export const ColFlexPropTypes = PropTypes.oneOf(['first', 'last', 'unordered'])

export const ColPushPropTypes = PropTypes.oneOf([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12
])

export const ColPullPropTypes = PropTypes.oneOf([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12
])

export const ColOffsetPropTypes = PropTypes.oneOf([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11
])

export const ColPropTypes = PropTypes.oneOf([
  true,
  'auto',
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12
])

export const NoGuttersPropTypes = PropTypes.bool



// WEBPACK FOOTER //
// ./src/components/Grid/types.js